// Footer.js (Create a new file for the Footer component)
import React from 'react';

const Footer = () => {
  return (
    <div className="footer ">
     <div className=" footer flex-grow"></div> {/* Empty flex item to push content to the right */}

      © 2023 SiliconHarry 
    </div>
  );
};

export default Footer;
